import { request } from 'api/request';
import { DELETE, PLATFORM_API_URLS, POST, PRODUCT_RESEARCH_API_URLS, PUT } from 'api/constants';

export default class Users {
  static checkEmail(data) {
    return request({
      url: PLATFORM_API_URLS.users.checkEmail,
      method: POST,
      data,
    });
  }

  static getUsersList(search) {
    return request({
      url: PLATFORM_API_URLS.users.usersList,
      search,
    });
  }

  static updateUser(params, data) {
    return request({
      url: PLATFORM_API_URLS.users.user,
      method: PUT,
      params,
      data,
    });
  }

  static getUserSettings() {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.userSettings.userSettings,
    });
  }

  static emailConfirmation(data) {
    return request({
      url: PLATFORM_API_URLS.users.emailConfirmation,
      method: POST,
      data,
    });
  }

  static initUser(data) {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.user.initUser,
      method: POST,
      data,
    });
  }

  static submitReview() {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.user.submitReview,
      method: POST,
    });
  }

  static activateChat(params) {
    return request({
      url: PLATFORM_API_URLS.users.activateChat,
      method: PUT,
      params,
    });
  }

  static getCometChatAuthToken() {
    return request({
      url: PLATFORM_API_URLS.users.cometChatAuthToken,
      method: POST,
    });
  }

  static deleteUser() {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.user.deleteUser,
      method: DELETE,
    });
  }
}
